(function () {
  'use strict';

  var CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"' +
    ' stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="18 15 12 9 6 15"></polyline>' +
    '</svg>';

  var COLLAPSE_STYLES =
    '.MW-config-product{transition:grid-template-rows 0.4s ease,max-height 0.4s ease;}' +
    'svg.category-tooltip-icon,svg.MW-category-tooltip-icon,.category-tooltip-icon svg,.MW-category-tooltip-icon svg{width:20px!important;height:20px!important;}' +
    '.mw-collapse-btn{position:absolute;top:37px;transform:translateY(-50%);left:8px;z-index:9999;width:28px;height:28px;' +
    'display:flex;align-items:center;justify-content:center;' +
    'background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.25);' +
    'border-radius:50%;cursor:pointer;color:#fff;padding:0;}' +
    '.mw-collapse-btn:hover{background:rgba(255,255,255,0.28);}' +
    '.mw-collapse-btn svg{display:block;transition:transform 0.3s ease;pointer-events:none;}' +
    '.mw-items-collapsed .mw-collapse-btn svg{transform:rotate(180deg);}' +
    '.mw-items-collapsed .items{pointer-events:none;}' +
    '.mw-items-collapsed{grid-template-rows:75px 0!important;max-height:75px!important;overflow:hidden!important;width:400px!important;}' +
    '.mobile-wrapper .mw-collapse-btn{display:none!important;}' +
    '.mobile-wrapper .mw-items-collapsed{grid-template-rows:unset!important;max-height:unset!important;overflow:unset!important;width:unset!important;}' +
    '.mobile-wrapper .mw-items-collapsed .items{pointer-events:auto!important;}';

  function getRoot() {
    // Try light DOM first
    if (document.querySelector('.MW-config-product')) return document;
    // Try shadow root of the custom element
    var host = document.querySelector('mw-configurator');
    if (host && host.shadowRoot && host.shadowRoot.querySelector('.MW-config-product')) {
      return host.shadowRoot;
    }
    return null;
  }

  function injectStylesIntoRoot(root) {
    if (root === document) return; // already handled by the external stylesheet
    if (root.querySelector('#mw-collapse-injected')) return;
    var style = document.createElement('style');
    style.id = 'mw-collapse-injected';
    style.textContent = COLLAPSE_STYLES;
    root.appendChild(style);
  }

  function initCollapse() {
    var root = getRoot();
    if (!root) return false;

    var panel = root.querySelector('.MW-config-product');
    if (!panel || panel.querySelector('.mw-collapse-btn')) return true; // already done

    injectStylesIntoRoot(root);

    var btn = document.createElement('button');
    btn.className = 'mw-collapse-btn';
    btn.setAttribute('aria-label', 'Expand item list');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = CHEVRON_SVG;

    panel.appendChild(btn);

    // Start collapsed by default
    panel.classList.add('mw-items-collapsed');

    btn.addEventListener('click', function () {
      var isNowCollapsed = panel.classList.toggle('mw-items-collapsed');
      btn.setAttribute('aria-expanded', String(!isNowCollapsed));
      btn.setAttribute('aria-label', isNowCollapsed ? 'Expand item list' : 'Collapse item list');
    });

    return true;
  }

  // Poll every 300ms for up to 30 seconds
  var attempts = 0;
  var maxAttempts = 100;
  var interval = setInterval(function () {
    attempts++;
    if (initCollapse() || attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 300);

  // MutationObserver on document body (catches light DOM)
  var observer = new MutationObserver(function () {
    if (initCollapse()) observer.disconnect();
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    // Also observe the shadow host once it exists
    waitForHost();
    initCollapse();
  }

  // Watch for mw-configurator shadow root to become available
  function waitForHost() {
    var hostCheck = setInterval(function () {
      var host = document.querySelector('mw-configurator');
      if (host && host.shadowRoot) {
        clearInterval(hostCheck);
        var shadowObserver = new MutationObserver(function () {
          if (initCollapse()) shadowObserver.disconnect();
        });
        shadowObserver.observe(host.shadowRoot, { childList: true, subtree: true });
        initCollapse();
      }
    }, 300);
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

  // ── Category Tooltip Modal (mobile) ──────────────────────────────────────
  (function () {
    var CTM_BP = 768;
    var ctmBackdrop    = null;
    var ctmModal       = null;
    var ctmTitleEl     = null;
    var ctmBodyEl      = null;
    var pendingTitle   = null;  // set on icon click, consumed when content arrives
    var popperWatcher  = null;  // MO watching popper for Vue-driven content
    var fallbackPoller = null;  // setInterval backup for Firefox MO gaps
    var safetyTimer    = null;
    var waitW1         = null;  // MO waiting for popper element (light DOM)
    var waitW2         = null;  // MO waiting for popper element (shadow DOM)

    // Search both light DOM and shadow root for the popper
    function findPopper() {
      var p = document.querySelector('.option-tooltip-popper');
      if (p) return p;
      var host = document.querySelector('mw-configurator');
      return (host && host.shadowRoot && host.shadowRoot.querySelector('.option-tooltip-popper')) || null;
    }

    var CTM_CSS =
      '#ctm-backdrop{display:none!important;position:fixed!important;inset:0!important;' +
      'z-index:2147483645!important;background:rgba(0,0,0,0.55)!important;' +
      'backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);}' +
      '#ctm-backdrop.ctm-open{display:block!important;}' +
      '#ctm-modal{display:none!important;position:fixed!important;top:50%!important;left:50%!important;' +
      'transform:translate(-50%,-50%)!important;z-index:2147483647!important;' +
      'background:var(--surface-dark,#1d2535)!important;' +
      'border-radius:10px!important;' +
      'padding:1.25rem 1.75rem!important;width:min(92vw,460px)!important;' +
      'max-height:80vh!important;overflow-y:auto!important;' +
      'border:2px solid var(--accent-green,#13F177)!important;' +
      'color:#fff!important;box-sizing:border-box!important;text-align:center!important;}' +
      '#ctm-modal.ctm-open{display:block!important;}' +
      '#ctm-modal,#ctm-modal *{color:#fff!important;background:transparent!important;' +
      'font-family:inherit;}' +
      '#ctm-modal{background:var(--surface-dark,#1d2535)!important;}' +
      '#ctm-modal-title{display:block!important;font-weight:700!important;font-size:1.9rem!important;' +
      'margin:0 0 .75rem!important;padding-right:3rem!important;' +
      'line-height:1.2!important;color:#fff!important;}' +
      '#ctm-modal-body{display:block!important;font-size:1.45rem!important;' +
      'font-weight:500!important;' +
      'line-height:1.6!important;color:#fff!important;}' +
      '#ctm-close-btn{position:absolute!important;top:.4rem!important;right:.4rem!important;' +
      'background:transparent!important;border:none!important;' +
      'color:#fff!important;width:48px!important;height:48px!important;' +
      'cursor:pointer!important;font-size:2.5rem!important;padding:0!important;' +
      'display:flex!important;align-items:center!important;justify-content:center!important;' +
      'opacity:0.8!important;}' +
      '#ctm-close-btn:hover{opacity:1!important;}' +
      // Hide the popper only while the modal is open
      'body.ctm-modal-open .option-tooltip-popper{display:none!important;visibility:hidden!important;}';

    function ensureStyles() {
      if (document.getElementById('ctm-injected-styles')) return;
      var s = document.createElement('style');
      s.id = 'ctm-injected-styles';
      s.textContent = CTM_CSS;
      (document.head || document.documentElement).appendChild(s);
    }

    // Inject styles immediately so the body-class CSS rules are ready before any click
    if (document.head || document.documentElement) {
      ensureStyles();
    } else {
      document.addEventListener('DOMContentLoaded', ensureStyles);
    }

    function ensureElements() {
      if (ctmBackdrop && ctmModal) return;
      if (!ctmBackdrop) {
        ctmBackdrop = document.createElement('div');
        ctmBackdrop.id = 'ctm-backdrop';
        ctmBackdrop.addEventListener('click', closeCtm);
        document.body.appendChild(ctmBackdrop);
      }
      if (!ctmModal) {
        ctmModal = document.createElement('div');
        ctmModal.id = 'ctm-modal';

        var closeBtn = document.createElement('button');
        closeBtn.id = 'ctm-close-btn';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.textContent = '\u00D7';
        closeBtn.addEventListener('click', closeCtm);

        ctmTitleEl = document.createElement('p');
        ctmTitleEl.id = 'ctm-modal-title';

        ctmBodyEl = document.createElement('div');
        ctmBodyEl.id = 'ctm-modal-body';

        ctmModal.appendChild(closeBtn);
        ctmModal.appendChild(ctmTitleEl);
        ctmModal.appendChild(ctmBodyEl);
        document.body.appendChild(ctmModal);
      }
    }

    function openCtm(title, bodyText) {
      ensureStyles();
      ensureElements();
      ctmTitleEl.textContent = title || '';
      ctmBodyEl.textContent  = bodyText || '';
      ctmBackdrop.classList.add('ctm-open');
      ctmModal.classList.add('ctm-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('ctm-modal-open');
    }

    function restorePopper() {
      var popper = findPopper();
      if (popper) {
        popper.style.removeProperty('opacity');
        popper.style.removeProperty('pointer-events');
        popper.style.removeProperty('visibility');
        popper.style.removeProperty('display');
      }
    }

    function closeCtm() {
      if (ctmBackdrop) ctmBackdrop.classList.remove('ctm-open');
      if (ctmModal)    ctmModal.classList.remove('ctm-open');
      document.documentElement.style.overflow = '';
      document.body.classList.remove('ctm-modal-open');
      // Defer restore so MW's own click-outside handler runs first and
      // removes/hides the popper before we make it visible again.
      setTimeout(restorePopper, 150);
    }

    // Tear down every pending wait mechanism atomically
    function clearAllWaiting() {
      if (safetyTimer)    { clearTimeout(safetyTimer);     safetyTimer    = null; }
      if (fallbackPoller) { clearInterval(fallbackPoller); fallbackPoller = null; }
      if (popperWatcher)  { popperWatcher.disconnect();    popperWatcher  = null; }
      if (waitW1) { waitW1.disconnect(); waitW1 = null; }
      if (waitW2) { waitW2.disconnect(); waitW2 = null; }
    }

    // Try to read content from popper and open modal.
    // Consumes pendingTitle on success; returns true if modal was opened.
    function tryOpenCtm(popper) {
      if (pendingTitle === null) return false;
      var tooltip = popper.querySelector('.option-tooltip');
      var text    = tooltip ? tooltip.textContent.trim() : '';
      if (!text) return false;
      var title = pendingTitle; pendingTitle = null;
      clearAllWaiting();
      openCtm(title, text);
      return true;
    }

    // Attach MO to popper + do an immediate synchronous check.
    function attachPopperWatcher(popper) {
      if (popperWatcher) { popperWatcher.disconnect(); popperWatcher = null; }
      popperWatcher = new MutationObserver(function () {
        if (window.innerWidth > CTM_BP || pendingTitle === null) return;
        tryOpenCtm(popper);
      });
      popperWatcher.observe(popper, { childList: true, subtree: true, characterData: true });
      tryOpenCtm(popper); // catch content already present
    }

    // Polling fallback — runs every 100 ms for up to 5 s alongside the MO.
    // Handles any Firefox edge case where the MO callback is delayed or missed.
    function startFallbackPoller() {
      if (fallbackPoller) { clearInterval(fallbackPoller); fallbackPoller = null; }
      var ticks = 0;
      fallbackPoller = setInterval(function () {
        ticks++;
        if (pendingTitle === null || ticks > 50) {
          clearInterval(fallbackPoller); fallbackPoller = null;
          if (ticks > 50) { pendingTitle = null; clearAllWaiting(); }
          return;
        }
        var popper = findPopper();
        if (!popper) return;
        // Re-attach MO if popper element was replaced since last check
        if (!popperWatcher) attachPopperWatcher(popper);
        tryOpenCtm(popper);
      }, 100);
    }

    function cancelWaitWatchers() {
      if (waitW1) { waitW1.disconnect(); waitW1 = null; }
      if (waitW2) { waitW2.disconnect(); waitW2 = null; }
    }

    // Watch for the popper element to appear in DOM (both light + shadow).
    function watchForPopper() {
      cancelWaitWatchers();
      waitW1 = new MutationObserver(function () {
        var found = findPopper();
        if (!found) return;
        cancelWaitWatchers();
        attachPopperWatcher(found);
      });
      waitW1.observe(document.body, { childList: true, subtree: true });
      var host = document.querySelector('mw-configurator');
      if (host && host.shadowRoot) {
        waitW2 = new MutationObserver(function () {
          var found = findPopper();
          if (!found) return;
          cancelWaitWatchers();
          attachPopperWatcher(found);
        });
        waitW2.observe(host.shadowRoot, { childList: true, subtree: true });
      }
    }

    // Pre-attach at page load
    (function () {
      var p = findPopper();
      if (p) attachPopperWatcher(p); else watchForPopper();
    }());

    document.addEventListener('click', function (e) {
      if (window.innerWidth > CTM_BP) return;

      var path = e.composedPath ? e.composedPath() : [];
      var icon = null;
      var cat  = null;

      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || typeof el.classList === 'undefined') continue;
        if (!icon && el.classList.contains('category-tooltip-icon')) {
          icon = el;
          if (icon.closest) {
            var closest = icon.closest('.MW-category');
            if (closest) { cat = closest; break; }
          }
          continue;
        }
        if (icon && el.classList.contains('MW-category')) { cat = el; break; }
      }

      if (!icon) return;

      // Reset all state from any previous click
      pendingTitle = null;
      clearAllWaiting();
      // Do NOT restore popper here — we're about to hide it again immediately,
      // and the style toggle confuses MW's own watchers on rapid clicks.

      var titleEl  = cat ? cat.querySelector('.category-title .text') : null;
      pendingTitle = titleEl ? titleEl.textContent.trim() : '';

      // Hide popper immediately — keeps layout intact for Vue/Popper.js
      // but prevents the flash before our modal opens
      var popper = findPopper();
      if (popper) {
        popper.style.opacity        = '0';
        popper.style.pointerEvents  = 'none';
        attachPopperWatcher(popper);          // immediate check + MO
        if (pendingTitle === null) return;    // already opened synchronously
      } else {
        watchForPopper();
      }

      // Polling fallback runs in parallel — Firefox safety net
      startFallbackPoller();

      // Hard cleanup after 5 s if nothing produced content
      safetyTimer = setTimeout(function () {
        pendingTitle = null;
        clearAllWaiting();
        restorePopper(); // unhide if we never got content
      }, 5000);
    }, true);

    // Hide tooltip during scroll so Popper.js lag doesn't cause stutter/jump
    (function () {
      var scrollHideTimer = null;
      function onScroll() {
        var popper = findPopper();
        if (popper) {
          popper.style.opacity       = '0';
          popper.style.pointerEvents = 'none';
        }
        clearTimeout(scrollHideTimer);
        scrollHideTimer = setTimeout(function () {
          var p = findPopper();
          if (p) {
            p.style.removeProperty('opacity');
            p.style.removeProperty('pointer-events');
          }
        }, 200);
      }
      // Capture phase catches scroll on any child container (e.g. .items overflow-y)
      window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    }());

  }());
})();

// Info-modal image galleries: keep the active pagination dot centered. The dot row is a fixed-width,
// overflow-hidden strip, so it only stops being centered at the first/last images (scroll is clamped).
// Option categories are identified by a custom CSS class set on the category in the configurator app (e.g. "nameplate_type"),
// not by the app's own category id (which differs between builders, e.g. nameplate_type vs conpro_nameplatetype).
// Each option info modal opened from an info icon in such a category is tagged with that class (data-category) and the option id (data-option),
// because the app gives the modal no id/class of its own and CSS/JS need it to target one category.
// On those modals it adds Prev/Next buttons that move to the previous/next option's modal (wrapping around) and select that option.
(function () {
  var rafId = null;
  var lastInfoCategory = null;
  var lastInfoOption = null;
  var handoff = null; // set while one option's modal is being swapped for another: { from, to, poll, timeout }
  var OPTION_NAV_CLASSES = ['nameplate_type'];
  var NAV_ICONS = {
    prev: '<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15.75 19.5L8.25 12l7.5-7.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
    next: '<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.25 4.5l7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
  };

  // Styles for the Prev/Next option buttons. Injected into the configurator's shadow root from here (not the theme CSS file),
  // because the configurator only reads the CSS saved in its own snippet editor and the buttons must work without it being updated.
  // They sit on the image edges; the app's own gallery arrows are hidden when these exist (images stay reachable via the dots or swiping).
  var NAV_CSS = [
    '.option-information-modal:has(.np-option-nav) .swiper-button-prev-custom,',
    '.option-information-modal:has(.np-option-nav) .swiper-button-next-custom { display: none; }',
    '.np-option-nav { position: absolute; top: calc(50% - 16px); z-index: 5; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; padding: 0; border: 1px solid #fff; border-radius: 9999px; background: rgba(0, 0, 0, .55); color: #fff; cursor: pointer; }',
    '.np-option-nav:hover, .np-option-nav:focus-visible { background: rgba(0, 0, 0, .8); }',
    '.np-option-nav svg { width: 16px; height: 16px; }',
    '.np-option-nav--prev { left: 8px; }',
    '.np-option-nav--next { right: 8px; }',
    // With several images the dots row (12px dots + 14px gap = 26px) sits under the image, so center on the image alone
    '.carousel-container:has(.carousel-controls:not(:has(.swiper-button-lock))) > .np-option-nav { top: calc((100% - 26px) / 2 - 16px); }',
    // One dot per option under the image; the current one is highlighted in the theme's accent green. ::after widens the tap area.
    '.np-option-dots { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; }',
    '.np-option-dot { position: relative; width: 12px; height: 12px; padding: 0; border: 1px solid #fff; border-radius: 9999px; background: transparent; cursor: pointer; }',
    '.np-option-dot::after { content: ""; position: absolute; inset: -4px; }',
    '.np-option-dot.is-active { background: var(--accent-green, #13F177); border-color: var(--accent-green, #13F177); }',
    '.np-option-dot:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }',
    // While swapping to another option's modal the new one is opened underneath and kept invisible until it is ready (it can sit above the
    // old modal in the page, and while loading it is an empty box). It is revealed in the same frame the old modal is removed.
    '.option-information-modal[data-handoff], .option-information-modal[data-handoff] * { visibility: hidden !important; }',
    '.option-information-modal[data-handoff] { background: transparent !important; -webkit-backdrop-filter: none !important; backdrop-filter: none !important; }',
    // Slow swap (e.g. the photo is not cached yet): dim the old modal after a short delay so it doesn't look frozen
    '.option-information-modal[data-swapping] .standalone-modal-content { opacity: .6; transition: opacity .2s ease .25s; }'
  ].join('\n');

  function injectNavStyles(root) {
    if (root.querySelector('#np-option-nav-styles')) return;
    var style = document.createElement('style');
    style.id = 'np-option-nav-styles';
    style.textContent = NAV_CSS;
    root.appendChild(style);
  }

  function centerActiveDots(root) {
    if (!root.querySelector('.option-information-modal')) return;
    root.querySelectorAll('.option-information-modal[data-category] .swiper-pagination-custom').forEach(function (pag) {
      var active = pag.querySelector('.swiper-pagination-bullet-active');
      if (!active || pag.scrollWidth <= pag.clientWidth) return;
      var left = active.offsetLeft - (pag.clientWidth - active.offsetWidth) / 2;
      pag.scrollTo({ left: left, behavior: 'smooth' });
    });
  }

  function tagInfoModals(root) {
    if (!lastInfoCategory) return;
    root.querySelectorAll('.option-information-modal:not([data-category])').forEach(function (modal) {
      modal.setAttribute('data-category', lastInfoCategory);
      if (lastInfoOption) modal.setAttribute('data-option', lastInfoOption);

      // The new modal of an option swap: keep it hidden until the old modal is removed, then wait for it to be ready
      if (handoff && !handoff.to && modal !== handoff.from) {
        handoff.to = modal;
        modal.setAttribute('data-handoff', '');
        handoff.poll = setInterval(checkHandoff, 30);
      }
    });
  }

  // Options of a category that have an info icon, in display order. `category` is the custom class on the category container.
  function infoOptions(root, category) {
    return Array.prototype.filter.call(
      root.querySelectorAll('.category.' + category + ' .MW-config-option-wrapper'),
      function (w) { return w.querySelector('.info-icon-wrapper'); }
    );
  }

  function optionLabel(wrapper) {
    var text = wrapper && wrapper.querySelector('.text');
    return text ? text.textContent.trim() : '';
  }

  function dispatchClick(el) {
    el.dispatchEvent(new MouseEvent('click', { bubbles: true, composed: true }));
  }

  // Select an option by clicking its button (no-op if it is already selected). Returns the option wrapper.
  function selectOption(root, category, optionId) {
    var wrapper = Array.prototype.find.call(infoOptions(root, category), function (w) { return w.id === optionId; });
    if (wrapper && !wrapper.classList.contains('wrapper-item-selected')) {
      var button = wrapper.querySelector('.mw-default-button');
      if (button) button.click();
    }
    return wrapper;
  }

  // Swap from this option's modal to another option's modal without a gap: select the option, open its modal (kept invisible),
  // leave the old modal on screen until the new one is fully drawn, then reveal the new one and remove the old one in the same frame.
  // (Closing first leaves an empty screen and the new modal appears collapsed, then grows; and a new modal that paints while its
  // photo is still downloading shows as an empty box.)
  function openOption(root, modal, category, targetId) {
    if (handoff || !selectOption(root, category, targetId)) return;
    var current = { from: modal, to: null, poll: null, timeout: null };
    handoff = current;
    modal.setAttribute('data-swapping', '');

    // Never leave the swap hanging: finish if the new modal is up but very slow, give up (old modal stays) if it never appeared
    current.timeout = setTimeout(function () {
      if (handoff !== current) return;
      if (current.to && !current.finishing) finishHandoff(); else clearHandoff();
    }, 8000);

    // Look the option up again: selecting it can re-render the option list
    setTimeout(function () {
      var fresh = Array.prototype.find.call(
        root.querySelectorAll('.category.' + category + ' .MW-config-option-wrapper'),
        function (w) { return w.id === targetId; }
      );
      var icon = fresh && fresh.querySelector('.info-icon');
      if (icon) dispatchClick(icon); else clearHandoff();
    }, 50);
  }

  function clearHandoff() {
    if (!handoff) return;
    clearInterval(handoff.poll);
    clearTimeout(handoff.timeout);
    if (handoff.to) handoff.to.removeAttribute('data-handoff');
    handoff.from.removeAttribute('data-swapping');
    handoff = null;
  }

  // The new modal is ready once its buttons exist and its photo has loaded.
  // (A modal without a gallery has neither, so it is ready as soon as its content is there.)
  function checkHandoff() {
    if (!handoff || !handoff.to || handoff.finishing) return;
    var to = handoff.to;
    if (!to.isConnected) { clearHandoff(); return; }
    var ready;
    if (to.querySelector('.carousel-container')) {
      var img = to.querySelector('img');
      ready = !!to.querySelector('.np-option-nav') && !!img && img.complete && img.naturalWidth > 0;
    } else {
      ready = !!to.querySelector('.standalone-modal-content');
    }
    if (ready) finishHandoff();
  }

  // Remove the old modal. The new modal stays hidden until the old one is really gone (settleHandoff),
  // so the swap happens within one frame: no empty box, no doubled or missing backdrop.
  function finishHandoff() {
    if (!handoff || handoff.finishing) return;
    handoff.finishing = true;
    clearInterval(handoff.poll);
    var from = handoff.from;
    var close = from.isConnected && from.querySelector('.standalone-modal-header .close');
    if (close) dispatchClick(close); else clearHandoff();
  }

  // Runs from the mutation observer, i.e. in the same microtask checkpoint that removed the old modal, before the next paint
  function settleHandoff() {
    if (handoff && handoff.finishing && !handoff.from.isConnected) clearHandoff();
  }

  // Go to the previous (-1) or next (1) option, wrapping around at the ends
  function goToOption(root, modal, step) {
    var category = modal.getAttribute('data-category');
    var options = infoOptions(root, category);
    var index = options.map(function (w) { return w.id; }).indexOf(modal.getAttribute('data-option'));
    if (index < 0 || options.length < 2) return;
    openOption(root, modal, category, options[(index + step + options.length) % options.length].id);
  }

  // Swipe left/right on the image moves to the next/previous option (touch devices), same as the buttons.
  // With several images Swiper handles the swipe until the first/last image; a swipe past either end continues to the neighbouring option.
  function addSwipe(root, modal, container) {
    var start = null;

    container.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { start = null; return; }
      var el = modal.querySelector('swiper-container');
      var swiper = el && el.swiper;
      var several = !!swiper && swiper.slides.length > 1;
      start = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
        swiperHandlesNext: several && !swiper.isEnd,
        swiperHandlesPrev: several && !swiper.isBeginning
      };
    }, { passive: true });

    container.addEventListener('touchend', function (e) {
      if (!start) return;
      var s = start;
      start = null;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - s.x;
      var dy = touch.clientY - s.y;
      // Needs a clear, mostly horizontal swipe so vertical scrolling and taps are left alone
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var step = dx < 0 ? 1 : -1;
      if (step === 1 ? s.swiperHandlesNext : s.swiperHandlesPrev) return;
      goToOption(root, modal, step);
    }, { passive: true });
  }

  function addOptionNav(root) {
    root.querySelectorAll('.option-information-modal[data-option]').forEach(function (modal) {
      var category = modal.getAttribute('data-category');
      if (OPTION_NAV_CLASSES.indexOf(category) === -1 || modal.querySelector('.np-option-nav')) return;
      var container = modal.querySelector('.carousel-container');
      var options = infoOptions(root, category);
      if (!container || options.length < 2) return;

      var index = options.map(function (w) { return w.id; }).indexOf(modal.getAttribute('data-option'));
      if (index < 0) return;

      [['prev', -1, 'Previous option'], ['next', 1, 'Next option']].forEach(function (def) {
        var neighbour = options[(index + def[1] + options.length) % options.length];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'np-option-nav np-option-nav--' + def[0];
        btn.setAttribute('aria-label', def[2] + ': ' + optionLabel(neighbour));
        btn.innerHTML = NAV_ICONS[def[0]];
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          goToOption(root, modal, def[1]);
        });
        container.appendChild(btn);
      });

      addSwipe(root, modal, container);

      // Dots go in the modal content (under the image) so they don't shift the buttons' vertical centering on the image
      var dots = document.createElement('div');
      dots.className = 'np-option-dots';
      options.forEach(function (w, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'np-option-dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to ' + optionLabel(w));
        if (i === index) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          if (i !== index) openOption(root, modal, category, w.id);
        });
        dots.appendChild(dot);
      });
      container.parentNode.appendChild(dots);
    });
  }

  function watch(root) {
    injectNavStyles(root);
    // Any click that isn't on an info icon of a listed category clears the category, so a modal opened some other way is never mis-tagged.
    // No timeout: the first open can be slow because the gallery loads lazily.
    root.addEventListener('click', function (e) {
      var icon = e.target.closest && e.target.closest('.info-icon-wrapper');
      var category = icon && icon.closest('.category');
      var key = category && OPTION_NAV_CLASSES.filter(function (c) { return category.classList.contains(c); })[0];
      var option = icon && icon.closest('.MW-config-option-wrapper');
      lastInfoCategory = key || null;
      lastInfoOption = key && option ? option.id : null;

      // Opening an option's info modal also selects that option (the app only opens the modal).
      // Deferred so the app's own click handling finishes first.
      if (lastInfoOption) {
        var selectCategory = lastInfoCategory;
        var selectId = lastInfoOption;
        setTimeout(function () { selectOption(root, selectCategory, selectId); }, 0);
      }
    }, true);

    var observer = new MutationObserver(function () {
      settleHandoff();
      tagInfoModals(root); // runs as a microtask, so the modal is tagged before it is first painted
      addOptionNav(root);
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        centerActiveDots(root);
      });
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  // The configurator renders into a shadow root after load, so poll for it (same approach as the code above)
  var attempts = 0;
  var timer = setInterval(function () {
    var host = document.querySelector('mw-configurator');
    if (host && host.shadowRoot) {
      clearInterval(timer);
      watch(host.shadowRoot);
    } else if (++attempts > 100) {
      clearInterval(timer);
    }
  }, 300);
})();
